var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#notification-bell_svg__clip0_2117_29955)",
    stroke: "#FF621D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M22.5 45a7.5 7.5 0 0015 0M43.125 5.625A24.073 24.073 0 0151.63 15M8.37 15a24.073 24.073 0 018.505-9.375"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.125 26.25a16.875 16.875 0 1133.75 0c0 8.395 1.945 13.266 3.492 15.938A1.874 1.874 0 0148.75 45h-37.5a1.875 1.875 0 01-1.613-2.813c1.545-2.671 3.488-7.544 3.488-15.937z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "notification-bell_svg__clip0_2117_29955"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgNotificationBell;